import axios from "axios";
const baseurl = process.env.REACT_APP_API_URL;

export const uploadLoanApplication = async (formData) => {
  const response = await axios({
    method: "post",
    url: baseurl + `/loanApply`,
    data: formData,
  });
  return response.data;
};
